$('body').on('click', function(e) {
	let target = $(e.target);
	if ((target.hasClass('widget-cart') || target.parents('.widget-cart').length) || (target.is('#search-bar') || target.parents('#search-bar').length) || (target.hasClass('js-mobile-navs') || target.parents('.js-mobile-navs').length) || (target.hasClass('btn-burger') || target.parents('.btn-burger').length)) {
		return;
	} else {
		if ($('.wrapper').hasClass('expand-cart')) {
			$('.wrapper').removeClass('expand-cart');
		}

		if ($('body').hasClass('menu-opened')) {
			$('body').removeClass('menu-opened');

			$('.menu__dropdown').slideUp();
			$('.js-mobile-nav li').removeClass('js-show');
		}

		if ($('#search-bar').hasClass('expanded')) {
			$('#search-bar').removeClass('expanded')
		}
	}
});
